import { CandidatLink } from '../components/candidat/CandidatLink';
import { FormationPicker } from '../components/formation/FormationPicker';
import React, { useState, useEffect, useCallback , useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle
} from '../components/ui/dialog';
import { toast } from 'sonner';
import { EcarterDialog } from '../components/candidat/EcarterDialog';
import { AbandonDialog } from '../components/candidat/AbandonPanel';
import {
  FolderOpen, Calendar, ChevronLeft, ChevronRight, Plus,
  ExternalLink, AlertTriangle, Check, ListChecks, Clock,
  Users, GraduationCap, FileText, Euro, TrendingUp, UserCheck,
  Pencil, Trash2, CalendarClock, History, Loader2, ArrowRight,
  CircleDot, Flag, Send, Briefcase, Search, EyeOff, LogOut, Siren, ChevronDown, CornerDownRight
} from 'lucide-react';
import { FormateursDisponiblesCard } from '../components/dashboard/FormateursDisponiblesCard';
import { DifficultesParFormation, ExportDifficultesWord } from '../components/dashboard/DifficultesParFormation';
import { format, startOfWeek, addDays, addWeeks, subWeeks, parseISO, isSameDay, differenceInDays } from 'date-fns';
import { fr } from 'date-fns/locale';
import { getAuthToken } from '../lib/authToken';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DOSSIER_COLORS = [
  { bg: 'bg-indigo-100', border: 'border-indigo-300', text: 'text-indigo-700', dot: 'bg-indigo-500' },
  { bg: 'bg-emerald-100', border: 'border-emerald-300', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  { bg: 'bg-amber-100', border: 'border-amber-300', text: 'text-amber-700', dot: 'bg-amber-500' },
  { bg: 'bg-rose-100', border: 'border-rose-300', text: 'text-rose-700', dot: 'bg-rose-500' },
  { bg: 'bg-sky-100', border: 'border-sky-300', text: 'text-sky-700', dot: 'bg-sky-500' },
  { bg: 'bg-violet-100', border: 'border-violet-300', text: 'text-violet-700', dot: 'bg-violet-500' },
  { bg: 'bg-teal-100', border: 'border-teal-300', text: 'text-teal-700', dot: 'bg-teal-500' },
];

const PRIORITE_CONFIG = {
  urgent: { label: 'Urgent', color: 'bg-red-100 text-red-700 border-red-200', icon: '!!' },
  normal: { label: 'Normal', color: 'bg-blue-100 text-blue-700 border-blue-200', icon: null },
  faible: { label: 'Faible', color: 'bg-slate-100 text-slate-500 border-slate-200', icon: null },
};

const CATEGORIE_CONFIG = {
  af: { label: 'AF', color: 'bg-indigo-100 text-indigo-700', icon: FolderOpen },
  financier: { label: 'Financier', color: 'bg-amber-100 text-amber-700', icon: Euro },
  commercial: { label: 'Commercial', color: 'bg-teal-100 text-teal-700', icon: TrendingUp },
};

const STATUT_CONFIG = {
  a_faire: { label: 'A faire', color: 'bg-slate-100 text-slate-600' },
  en_cours: { label: 'En cours', color: 'bg-blue-100 text-blue-700' },
  termine: { label: 'Termine', color: 'bg-emerald-100 text-emerald-700' },
};

export const DashboardPage = () => {
  const [stats, setStats] = useState(null);
  const [allDossiers, setAllDossiers] = useState([]);
  const [formateurs, setFormateurs] = useState([]);
  const [formations, setFormations] = useState([]);
  const [taches, setTaches] = useState([]);
  const [adminUsers, setAdminUsers] = useState([]);
  const [currentWeek, setCurrentWeek] = useState(startOfWeek(new Date(), { weekStartsOn: 1 }));
  const [loading, setLoading] = useState(true);
  const [taskFilter, setTaskFilter] = useState('all');
  const [taskStatusFilter, setTaskStatusFilter] = useState('pending');
  const [tachesOpen, setTachesOpen] = useState(false);
  const [demandesCom, setDemandesCom] = useState({});
  const [taskDialogOpen, setTaskDialogOpen] = useState(false);
  const [reportDialogOpen, setReportDialogOpen] = useState(false);
  const [editTask, setEditTask] = useState(null);
  const [reportTask, setReportTask] = useState(null);
  const [reportForm, setReportForm] = useState({ nouvelle_date: '', raison: '' });
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [historyTask, setHistoryTask] = useState(null);
  const [taskForm, setTaskForm] = useState({
    titre: '', description: '', categorie: 'af', priorite: 'normal',
    date_objectif: '', assigne_a: '', dossier_id: '', dossier_code: ''
  });

  // Traitement demande de devis
  const navigate = useNavigate();
  const [traiterDialogOpen, setTraiterDialogOpen] = useState(false);
  const [traiterTask, setTraiterTask] = useState(null);
  const [traiterMode, setTraiterMode] = useState('existante'); // 'existante' ou 'nouvelle'
  const [traiterForm, setTraiterForm] = useState({
    action_formation_id: '', formation_id: '', intitule: '', lieu_principal: '',
  });
  const [financeurs, setFinanceurs] = useState([]);
  const [traiterLoading, setTraiterLoading] = useState(false);
  const [alertesNA, setAlertesNA] = useState([]);
  const [candidatsEC, setCandidatsEC] = useState(null);
  const [listCandOpen, setListCandOpen] = useState(false);
  const [diffOpen, setDiffOpen] = useState(false);

  const headers = useMemo(() => ({ Authorization: `Bearer ${getAuthToken()}` }), []);

  const fetchData = useCallback(async () => {
    try {
      const [statsRes, dossiersRes, formateursRes, formationsRes, tachesRes, , usersRes, financeursRes, alertesRes, candEcRes] = await Promise.all([
        axios.get(`${API_URL}/dashboard/stats-direction`, { headers }),
        axios.get(`${API_URL}/dossiers`, { headers }),
        axios.get(`${API_URL}/formateurs`, { headers }),
        axios.get(`${API_URL}/formations`, { headers }),
        axios.get(`${API_URL}/taches`, { headers }),
        axios.get(`${API_URL}/projets-commerciaux/compteurs`, { headers }).then(r => setDemandesCom(r.data)).catch(() => {}),
        axios.get(`${API_URL}/admin/users`, { headers }).catch(() => ({ data: [] })),
        axios.get(`${API_URL}/financeurs`, { headers }).catch(() => ({ data: [] })),
        axios.get(`${API_URL}/alertes/competences-faibles`, { headers }).catch(() => ({ data: [] })),
        axios.get(`${API_URL}/dashboard/candidats-en-cours`, { headers }).catch(() => ({ data: null })),
      ]);
      setStats(statsRes.data);
      setAllDossiers(dossiersRes.data);
      setFormateurs(formateursRes.data);
      setFormations(formationsRes.data);
      setTaches(tachesRes.data);
      setAdminUsers(usersRes.data);
      setFinanceurs(financeursRes.data);
      setAlertesNA(alertesRes.data || []);
      setCandidatsEC(candEcRes.data);
    } catch (error) {
      // erreur silencieuse
    } finally {
      setLoading(false);
    }
  }, [headers]);

  const [abandonCible, setAbandonCible] = useState(null);
  const refreshDifficultes = async () => {
    const [alertesRes, candEcRes] = await Promise.all([
      axios.get(`${API_URL}/alertes/competences-faibles`, { headers }).catch(() => ({ data: [] })),
      axios.get(`${API_URL}/dashboard/candidats-en-cours`, { headers }).catch(() => ({ data: null })),
    ]);
    setAlertesNA(alertesRes.data || []); setCandidatsEC(candEcRes.data);
  };
  const [ecarterCible, setEcarterCible] = useState(null);
  const ignorerDifficulte = (e) => setEcarterCible(e);
  const confirmerEcart = async (motif) => {
    const e = ecarterCible;
    try {
      await axios.post(`${API_URL}/alertes/difficultes/ignorer`, { candidat_id: e.candidat_id, dossier_id: e.dossier_id, motif,
        cause: { nb_na: e.nb_na, na_details: e.na_details, nb_absences: e.nb_absences, absences_dates: e.absences_dates, suspicion_abandon: e.suspicion_abandon, dossier_code: e.dossier_code, candidat_nom: e.candidat_nom } }, { headers });
      const [alertesRes, candEcRes] = await Promise.all([
        axios.get(`${API_URL}/alertes/competences-faibles`, { headers }).catch(() => ({ data: [] })),
        axios.get(`${API_URL}/dashboard/candidats-en-cours`, { headers }).catch(() => ({ data: null })),
      ]);
      setAlertesNA(alertesRes.data || []); setCandidatsEC(candEcRes.data);
      toast.success('Difficulté écartée — motif enregistré');
    } catch (err) { toast.error(err.response?.data?.detail || 'Erreur'); throw err; }
  };

  useEffect(() => { fetchData(); }, [fetchData]);

  // === TASK HANDLERS ===
  const openCreateTask = () => {
    setEditTask(null);
    setTaskForm({
      titre: '', description: '', categorie: taskFilter !== 'all' ? taskFilter : 'af',
      priorite: 'normal', date_objectif: '', assigne_a: '', dossier_id: '', dossier_code: ''
    });
    setTaskDialogOpen(true);
  };

  const openEditTask = (t) => {
    setEditTask(t);
    setTaskForm({
      titre: t.titre, description: t.description || '', categorie: t.categorie,
      priorite: t.priorite, date_objectif: t.date_objectif || '',
      assigne_a: t.assigne_a || '', dossier_id: t.dossier_id || '', dossier_code: t.dossier_code || ''
    });
    setTaskDialogOpen(true);
  };

  const saveTask = async () => {
    if (!taskForm.titre) { toast.error('Titre requis'); return; }
    try {
      if (editTask) {
        await axios.put(`${API_URL}/taches/${editTask.id}`, taskForm, { headers });
        toast.success('Tache mise a jour');
      } else {
        await axios.post(`${API_URL}/taches`, { ...taskForm, type: 'manuelle' }, { headers });
        toast.success('Tache creee');
      }
      setTaskDialogOpen(false);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    }
  };

  const changeStatus = async (taskId, newStatus) => {
    try {
      await axios.patch(`${API_URL}/taches/${taskId}/statut`, { statut: newStatus }, { headers });
      fetchData();
    } catch {}
  };

  const deleteTask = async (taskId) => {
    if (!window.confirm('Supprimer cette tache ?')) return;
    try {
      await axios.delete(`${API_URL}/taches/${taskId}`, { headers });
      toast.success('Tache supprimee');
      fetchData();
    } catch {}
  };

  const openReportDialog = (t) => {
    setReportTask(t);
    setReportForm({ nouvelle_date: '', raison: '' });
    setReportDialogOpen(true);
  };

  const submitReport = async () => {
    if (!reportForm.nouvelle_date || !reportForm.raison) {
      toast.error('Date et raison obligatoires');
      return;
    }
    try {
      await axios.patch(`${API_URL}/taches/${reportTask.id}/reporter`, reportForm, { headers });
      toast.success('Date reportee');
      setReportDialogOpen(false);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    }
  };

  // === TRAITEMENT DEVIS HANDLERS ===
  const openTraiterDialog = (task) => {
    const dd = task.demande_devis;
    setTraiterTask(task);
    setTraiterMode(dd?.action_formation_id ? 'existante' : 'nouvelle');
    setTraiterForm({
      action_formation_id: dd?.action_formation_id || '',
      formation_id: '', intitule: dd?.objet || '',
      lieu_principal: dd?.lieu || '',
    });
    setTraiterDialogOpen(true);
  };

  const submitTraiter = async () => {
    if (traiterMode === 'existante' && !traiterForm.action_formation_id) {
      toast.error('Selectionnez une AF existante'); return;
    }
    if (traiterMode === 'nouvelle' && !traiterForm.formation_id) {
      toast.error('Selectionnez une formation'); return;
    }
    setTraiterLoading(true);
    try {
      const payload = {
        creer_af: traiterMode === 'nouvelle',
        action_formation_id: traiterMode === 'existante' ? traiterForm.action_formation_id : null,
        formation_id: traiterForm.formation_id || null,
        intitule: traiterForm.intitule,
        lieu_principal: traiterForm.lieu_principal,
      };
      const res = await axios.post(
        `${API_URL}/commercial/demandes-devis/${traiterTask.demande_devis_id}/traiter`,
        payload, { headers }
      );
      toast.success(`${res.data.message} — ${res.data.action_formation_code}. Completez le dossier pour generer le devis.`);
      setTraiterDialogOpen(false);
      // Redirect to AF page for the admin to complete (financeur, candidats, dates, devis)
      navigate(`/dossiers/${res.data.action_formation_id}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur lors du traitement');
    } finally {
      setTraiterLoading(false);
    }
  };

  // === PLANNING HELPERS ===
  const weekDays = Array.from({ length: 7 }, (_, i) => addDays(currentWeek, i));
  const weekEnd = addDays(currentWeek, 6);

  const dossiersOfWeek = allDossiers.filter(dossier => {
    if (dossier.statut === 'termine' || dossier.statut === 'abandon' || dossier.statut === 'cloture') return false;
    const weekStartStr = format(currentWeek, 'yyyy-MM-dd');
    const weekEndStr = format(weekEnd, 'yyyy-MM-dd');
    return dossier.planning?.some(p => p.date >= weekStartStr && p.date <= weekEndStr);
  });

  const getDossiersForDay = (day) => {
    const dayStr = format(day, 'yyyy-MM-dd');
    const results = [];
    dossiersOfWeek.forEach((dossier) => {
      const globalIdx = allDossiers.findIndex(d => d.id === dossier.id);
      const planningEntries = dossier.planning?.filter(p => p.date === dayStr) || [];
      if (planningEntries.length > 0) {
        results.push({ dossier, planningEntries, colorIndex: (globalIdx >= 0 ? globalIdx : 0) % DOSSIER_COLORS.length });
      }
    });
    // AFT rangées juste sous leur AF mère (ou en fin de liste si la mère n'est pas ce jour-là)
    const meres = results.filter(r => r.dossier.type_dossier !== 'aft');
    const afts = results.filter(r => r.dossier.type_dossier === 'aft');
    const ordered = [];
    meres.forEach(m => { ordered.push(m); afts.filter(a => a.dossier.af_mere_id === m.dossier.id).forEach(a => ordered.push({ ...a, sousMere: true })); });
    afts.filter(a => !meres.some(m => m.dossier.id === a.dossier.af_mere_id)).forEach(a => ordered.push(a));
    return ordered;
  };

  const getFormateurInitials = (fId) => {
    const f = formateurs.find(x => x.id === fId);
    return f ? `${f.prenom?.[0] || ''}${f.nom?.[0] || ''}`.toUpperCase() : '';
  };

  const getFormateurName = (fId) => {
    const f = formateurs.find(x => x.id === fId);
    return f ? `${f.nom} ${f.prenom}` : '';
  };

  const getRetard = (dateObjectif) => {
    if (!dateObjectif) return null;
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const obj = parseISO(dateObjectif);
    const diff = differenceInDays(obj, today);
    if (diff < 0) return { label: `${Math.abs(diff)}j de retard`, color: 'text-red-600 bg-red-50 border-red-200', isLate: true };
    if (diff === 0) return { label: "Aujourd'hui", color: 'text-amber-600 bg-amber-50 border-amber-200', isLate: false };
    if (diff <= 3) return { label: `J-${diff}`, color: 'text-amber-500 bg-amber-50 border-amber-200', isLate: false };
    return { label: `J-${diff}`, color: 'text-slate-500 bg-slate-50 border-slate-200', isLate: false };
  };

  // === FILTERED TASKS ===
  const filteredTasks = taches.filter(t => {
    if (taskFilter !== 'all' && t.categorie !== taskFilter) return false;
    if (taskStatusFilter === 'pending' && t.statut === 'termine') return false;
    if (taskStatusFilter === 'termine' && t.statut !== 'termine') return false;
    return true;
  }).sort((a, b) => {
    const prio = { urgent: 0, normal: 1, faible: 2 };
    if (prio[a.priorite] !== prio[b.priorite]) return prio[a.priorite] - prio[b.priorite];
    if (a.date_objectif && b.date_objectif) return a.date_objectif.localeCompare(b.date_objectif);
    if (a.date_objectif) return -1;
    return 1;
  });

  if (loading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-64">
          <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
        </div>
      </DashboardLayout>
    );
  }

  const s = stats || {};
  const af = s.af || {};
  const fin = s.financier || {};
  const fmt = s.formateurs || {};
  const tStats = s.taches || {};

  return (
    <DashboardLayout>
      <div className="space-y-6" data-testid="dashboard-page">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold text-slate-900 font-['Plus_Jakarta_Sans']">Tableau de bord</h1>
            <p className="text-slate-500 text-sm mt-1">Vue d'ensemble de votre activite</p>
          </div>
          <div className="flex gap-2">
            <Button asChild variant="outline" className="border-indigo-200 text-indigo-700 hover:bg-indigo-50" data-testid="affectation-btn">
              <Link to="/planning"><Calendar className="w-4 h-4 mr-2" />Planning</Link>
            </Button>
            <Button asChild className="bg-indigo-600 hover:bg-indigo-700">
              <Link to="/dossiers/new" data-testid="new-dossier-btn"><Plus className="w-4 h-4 mr-2" />Nouvelle AF</Link>
            </Button>
          </div>
        </div>

        {/* Stats Cards Row */}
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-3" data-testid="stats-cards">
          <Card
            className="border-0 shadow-sm cursor-pointer hover:shadow-md hover:ring-1 hover:ring-indigo-200 transition-all"
            onClick={() => navigate('/dossiers?statut=en_cours')}
            data-testid="tile-af-en-cours"
          >
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-indigo-100 flex items-center justify-center">
                  <FolderOpen className="w-5 h-5 text-indigo-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900">{af.en_cours || 0}</p>
                  <p className="text-[11px] text-slate-500">AF en cours</p>
                </div>
              </div>
              <div className="mt-3 flex gap-2 text-[10px]">
                <span className="px-1.5 py-0.5 rounded bg-emerald-50 text-emerald-600">{af.terminees || 0} terminees</span>
                <span className="px-1.5 py-0.5 rounded bg-sky-50 text-sky-600">{af.a_venir || 0} a venir</span>
              </div>
            </CardContent>
          </Card>

          <Card
            className="border-0 shadow-sm cursor-pointer hover:shadow-md hover:ring-1 hover:ring-emerald-200 transition-all"
            onClick={() => setListCandOpen(true)}
            data-testid="tile-candidats-en-formation"
          >
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center">
                  <GraduationCap className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900">{candidatsEC?.total ?? (s.candidats?.total || 0)}</p>
                  <p className="text-[11px] text-slate-500">Candidats en formation</p>
                </div>
              </div>
              <div className="mt-3 flex gap-2 text-[10px]">
                <button
                  type="button"
                  onClick={(e) => { e.stopPropagation(); setDiffOpen(true); }}
                  className={`px-1.5 py-0.5 rounded font-semibold transition-colors ${(candidatsEC?.nb_en_difficulte || 0) > 0 ? 'bg-red-50 text-red-600 hover:bg-red-100' : 'bg-emerald-50 text-emerald-600'}`}
                  data-testid="badge-candidats-difficulte"
                >
                  {candidatsEC?.nb_en_difficulte || 0} en difficulté
                </button>
                <span className="px-1.5 py-0.5 rounded bg-slate-50 text-slate-500">{s.candidats?.total || 0} au total</span>
              </div>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-sm">
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center">
                  <UserCheck className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900">{fmt.total || 0}</p>
                  <p className="text-[11px] text-slate-500">Formateurs</p>
                </div>
              </div>
              <div className="mt-3">
                <div className="flex items-center gap-2">
                  <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                    <div className="h-full bg-blue-500 rounded-full" style={{ width: `${fmt.taux_occupation || 0}%` }} />
                  </div>
                  <span className="text-[10px] text-slate-500 font-medium">{fmt.taux_occupation || 0}%</span>
                </div>
                <p className="text-[10px] text-slate-400 mt-0.5">{fmt.actifs_ce_mois || 0} actif(s) ce mois</p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-sm">
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center">
                  <Euro className="w-5 h-5 text-amber-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900">{(fin.ca_facture || 0).toLocaleString('fr-FR')} EUR</p>
                  <p className="text-[11px] text-slate-500">CA Facture</p>
                </div>
              </div>
              <div className="mt-3 flex gap-2 text-[10px]">
                <span className="px-1.5 py-0.5 rounded bg-amber-50 text-amber-600">{fin.devis_count || 0} devis</span>
                <span className="px-1.5 py-0.5 rounded bg-violet-50 text-violet-600">{fin.factures_count || 0} factures</span>
              </div>
            </CardContent>
          </Card>

          <Card className={`border-0 shadow-sm cursor-pointer hover:shadow-md transition-shadow relative ${(demandesCom.demandes_af || 0) > 0 ? 'ring-2 ring-red-300' : (demandesCom.a_traiter || 0) > 0 ? 'ring-1 ring-amber-300' : ''}`} onClick={() => navigate((demandesCom.demandes_af || 0) > 0 ? '/commercial?filtre=demandes_af' : '/commercial')} data-testid="tuile-demandes-commerciales">
            {(demandesCom.demandes_af || 0) > 0 && (
              <span className="absolute -top-2 -right-2 flex h-5 min-w-[20px] px-1 items-center justify-center rounded-full bg-red-600 text-white text-[11px] font-bold shadow animate-pulse" data-testid="badge-demandes-af">{demandesCom.demandes_af}</span>
            )}
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${(demandesCom.demandes_af || 0) > 0 ? 'bg-red-100' : (demandesCom.a_traiter || 0) > 0 ? 'bg-amber-100' : 'bg-slate-100'}`}>
                  <Briefcase className={`w-5 h-5 ${(demandesCom.demandes_af || 0) > 0 ? 'text-red-600' : (demandesCom.a_traiter || 0) > 0 ? 'text-amber-600' : 'text-slate-500'}`} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900" data-testid="demandes-commerciales-count">{demandesCom.a_traiter || 0}</p>
                  <p className="text-[11px] text-slate-500">Demandes commerciales</p>
                </div>
              </div>
              <div className="mt-3 flex gap-2 text-[10px] flex-wrap">
                {demandesCom.demandes_af > 0 && <button type="button" onClick={(e) => { e.stopPropagation(); navigate('/commercial?filtre=demandes_af'); }} className="px-1.5 py-0.5 rounded bg-red-50 text-red-700 font-bold hover:bg-red-100" data-testid="label-demandes-af">{demandesCom.demandes_af} demande(s) d'AF</button>}
                {demandesCom.nouveaux > 0 && <button type="button" onClick={(e) => { e.stopPropagation(); navigate('/commercial?filtre=nouveau'); }} className="px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 font-semibold hover:bg-amber-100" data-testid="label-nouveaux">{demandesCom.nouveaux} nouvelle(s)</button>}
                <button type="button" onClick={(e) => { e.stopPropagation(); navigate('/commercial?filtre=ouverts'); }} className="px-1.5 py-0.5 rounded bg-slate-50 text-slate-500 hover:bg-slate-100" data-testid="label-projets-ouverts">{demandesCom.total_ouverts || 0} projet(s) ouvert(s)</button>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Dialog : candidats en formation */}
        <Dialog open={listCandOpen} onOpenChange={setListCandOpen}>
          <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-testid="dialog-candidats-en-formation">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <GraduationCap className="w-5 h-5 text-emerald-600" /> Candidats en formation ({candidatsEC?.total || 0})
              </DialogTitle>
            </DialogHeader>
            <div className="divide-y">
              {(candidatsEC?.candidats || []).map(c => (
                <div key={c.candidat_id} className="py-2.5 flex items-center justify-between gap-3" data-testid={`candidat-ec-row-${c.candidat_id}`}>
                  <div className="flex items-center gap-2 min-w-0">
                    {c.en_difficulte && <AlertTriangle className="w-3.5 h-3.5 text-red-500 shrink-0" />}
                    <span className="text-sm font-medium text-slate-800 truncate">{c.nom_complet}</span>
                  </div>
                  <div className="flex items-center gap-1.5 flex-wrap justify-end">
                    {c.dossiers.map(d => (
                      <Link key={d.id} to={`/dossiers/${d.id}`} title={d.intitule} className="text-[10px] font-mono text-indigo-600 bg-indigo-50 px-1.5 py-0.5 rounded hover:bg-indigo-100">{d.code}</Link>
                    ))}
                  </div>
                </div>
              ))}
              {(candidatsEC?.candidats || []).length === 0 && (
                <p className="text-sm text-slate-400 italic py-4 text-center">Aucun candidat sur les formations en cours</p>
              )}
            </div>
          </DialogContent>
        </Dialog>

        {/* Dialog : candidats en difficulté */}
        <Dialog open={diffOpen} onOpenChange={setDiffOpen}>
          <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="dialog-candidats-difficulte">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2 text-red-700">
                <AlertTriangle className="w-5 h-5" /> Candidats en difficulté ({candidatsEC?.nb_en_difficulte || 0})
              </DialogTitle>
            </DialogHeader>
            <div className="flex items-start justify-between gap-3 -mt-2">
              <p className="text-xs text-slate-500">Compétences "Non Acquis" (2 et plus), absences prolongées (4 et plus) ou suspicion d'abandon signalée par le formateur, sur les formations en cours. Regroupés par action de formation.</p>
              <ExportDifficultesWord />
            </div>
            <DifficultesParFormation entries={candidatsEC?.en_difficulte || []} onAbandon={setAbandonCible} onIgnorer={ignorerDifficulte} />
            {abandonCible && (
              <AbandonDialog open onOpenChange={(o) => !o && setAbandonCible(null)} dossierId={abandonCible.dossier_id} suspicion={abandonCible.suspicion_abandon}
                candidat={{ id: abandonCible.candidat_id, nom: abandonCible.candidat_nom, prenom: '' }} onDone={() => { setAbandonCible(null); refreshDifficultes(); }} />
            )}
          </DialogContent>
        </Dialog>
        {/* Dialogue d'écart rendu hors du dialogue principal (évite le piège de focus des dialogues imbriqués) */}
        {ecarterCible && (
          <EcarterDialog open onOpenChange={(o) => !o && setEcarterCible(null)} titre={`Écarter la difficulté — ${ecarterCible.candidat_nom}`} onConfirm={confirmerEcart} testId="difficulte-ecarter-dialog"
            cause={<>
              <p className="font-semibold">{ecarterCible.dossier_code} · {ecarterCible.dossier_intitule}</p>
              {ecarterCible.nb_na > 0 && <p>{ecarterCible.nb_na} compétence(s) non acquise(s){(ecarterCible.na_details || []).length ? ' : ' + ecarterCible.na_details.map(d => (d.competence || d.test_titre || '').trim()).filter(Boolean).join(' ; ') : ''}</p>}
              {ecarterCible.nb_absences > 0 && <p>{ecarterCible.nb_absences} absence(s) : {(ecarterCible.absences_dates || []).map(d => d ? new Date(d + 'T00:00:00').toLocaleDateString('fr-FR') : '—').join(' · ')}</p>}
              {ecarterCible.suspicion_abandon && <p>Suspicion d'abandon signalée par {ecarterCible.suspicion_abandon.signale_par_nom} : <span className="whitespace-pre-wrap">{ecarterCible.suspicion_abandon.motif}</span></p>}
            </>} />
        )}

        {/* Planning Hebdo - compact */}
        <Card className="border-0 shadow-sm" data-testid="weekly-planning">
          <CardHeader className="border-b bg-slate-50/50 pb-3">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <CardTitle className="flex items-center gap-2 text-base font-['Plus_Jakarta_Sans']">
                <Calendar className="w-4 h-4 text-indigo-600" />
                Planning hebdomadaire
                {dossiersOfWeek.length > 0 && <span className="text-xs font-normal text-slate-400 ml-1">({dossiersOfWeek.length} AF)</span>}
              </CardTitle>
              <div className="flex items-center gap-2">
                <Button variant="outline" size="icon" className="h-7 w-7" onClick={() => setCurrentWeek(subWeeks(currentWeek, 1))} data-testid="week-prev">
                  <ChevronLeft className="w-3.5 h-3.5" />
                </Button>
                <span className="text-xs font-medium sm:min-w-[180px] text-center whitespace-nowrap">
                  {format(currentWeek, "d MMM", { locale: fr })} - {format(weekEnd, "d MMM yyyy", { locale: fr })}
                </span>
                <Button variant="outline" size="icon" className="h-7 w-7" onClick={() => setCurrentWeek(addWeeks(currentWeek, 1))} data-testid="week-next">
                  <ChevronRight className="w-3.5 h-3.5" />
                </Button>
              </div>
            </div>
          </CardHeader>
          <CardContent className="p-0 overflow-x-auto">
            <div className="min-w-[560px]">
            <div className="grid grid-cols-7 border-b bg-slate-50">
              {weekDays.map((day, idx) => {
                const today = isSameDay(day, new Date());
                return (
                  <div key={format(day, 'yyyy-MM-dd')} className={`p-2 text-center border-r last:border-r-0 ${today ? 'bg-indigo-50' : ''}`}>
                    <p className="text-[10px] font-medium text-slate-400 uppercase">{format(day, 'EEE', { locale: fr })}</p>
                    <p className={`text-lg font-semibold ${today ? 'text-indigo-600' : 'text-slate-900'}`}>{format(day, 'd')}</p>
                  </div>
                );
              })}
            </div>
            <div className="grid grid-cols-7 min-h-[180px]" data-testid="weekly-calendar-grid">
              {weekDays.map((day, dayIdx) => {
                const dayDossiers = getDossiersForDay(day);
                const today = isSameDay(day, new Date());
                return (
                  <div key={dayIdx} className={`border-r last:border-r-0 p-1.5 ${today ? 'bg-indigo-50/30' : ''} min-h-[180px]`}>
                    {dayDossiers.length === 0 ? (
                      <div className="h-full flex items-center justify-center"><span className="text-xs text-slate-300">-</span></div>
                    ) : (
                      <div className="space-y-1">
                        {dayDossiers.map(({ dossier, planningEntries, colorIndex, sousMere }) => {
                          const colors = DOSSIER_COLORS[colorIndex];
                          if (dossier.type_dossier === 'aft') {
                            const mere = allDossiers.find(d => d.id === dossier.af_mere_id);
                            return (
                              <Link key={`${dossier.id}-${dayIdx}`} to={`/dossiers/${dossier.id}`} title={`${dossier.code} — ${dossier.intitule}${mere ? `\n↳ rattachée à ${mere.code} — ${mere.intitule}` : ''}`}
                                className={`flex items-start gap-0.5 py-0.5 px-1 rounded border border-cyan-300 bg-cyan-50 hover:bg-cyan-100 transition-colors ${sousMere ? 'ml-3' : ''}`} data-testid={`dashboard-aft-${dossier.id}-${format(day, 'yyyy-MM-dd')}`}>
                                <CornerDownRight className="w-2.5 h-2.5 text-cyan-600 shrink-0 mt-px" />
                                <span className="min-w-0 leading-tight">
                                  <span className="block text-[8px] font-bold text-cyan-800 truncate">AFT · {(dossier.intitule || '').replace(/^Session d'examen\s*/i, '')}</span>
                                  {mere && !sousMere && <span className="block text-[7px] text-cyan-600 truncate">→ {mere.code}</span>}
                                </span>
                              </Link>
                            );
                          }
                          return (
                            <Link key={`${dossier.id}-${dayIdx}`} to={`/dossiers/${dossier.id}`}
                              className={`block p-1.5 rounded-md border ${colors.bg} ${colors.border} hover:shadow-md transition-all`} title={dossier.intitule}>
                              <div className="flex items-center justify-between gap-1">
                                <span className={`text-[9px] font-mono font-bold ${colors.text} truncate leading-tight`} data-testid={`dashboard-af-code-${dossier.id}-${format(day, 'yyyy-MM-dd')}`}>{dossier.code}</span>
                                <span className="flex gap-0.5 shrink-0">
                                  {planningEntries.map((entry, i) => entry.formateur_id && (
                                    <span key={`${entry.formateur_id}-${entry.demi_journee || ''}-${i}`} className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-white text-[8px] font-bold text-slate-600 border" title={getFormateurName(entry.formateur_id)}>
                                      {getFormateurInitials(entry.formateur_id)}
                                    </span>
                                  ))}
                                </span>
                              </div>
                              <p className={`text-[10px] font-semibold ${colors.text} truncate leading-tight mt-0.5`}>{dossier.intitule}</p>
                            </Link>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            </div>
          </CardContent>
        </Card>

        {/* Alerte compétences faibles */}
        {alertesNA.length > 0 && (
          <Card className="border border-red-200 bg-red-50/40 shadow-sm" data-testid="alertes-competences-card">
            <CardContent className="p-4">
              <h3 className="text-sm font-semibold text-red-800 flex items-center gap-2 mb-2">
                <AlertTriangle className="w-4 h-4" />
                Candidats en difficulté — compétences "Non Acquis" ({alertesNA.length}) <span className="text-[10px] font-normal text-red-500">formations en cours uniquement</span>
              </h3>
              <div className="space-y-1.5">
                {alertesNA.map((a, i) => (
                  <div key={i} className="flex items-center justify-between gap-3 bg-white rounded-lg px-3 py-2 border border-red-100" data-testid={`alerte-na-${a.candidat_id}`}>
                    <div className="flex items-center gap-2 flex-wrap min-w-0">
                      <CandidatLink dossierId={a.dossier_id} candidatId={a.candidat_id} className="text-sm font-medium">{a.candidat_nom}</CandidatLink>
                      {a.dossier_code && (
                        <Link to={`/dossiers/${a.dossier_id}`} className="text-[10px] font-mono text-indigo-600 bg-indigo-50 px-1.5 py-0.5 rounded hover:bg-indigo-100">{a.dossier_code}</Link>
                      )}
                      <span className="text-[10px] text-slate-400 truncate">
                        {(a.details || []).slice(0, 3).map(d => d.competence || d.test_titre).filter(Boolean).join(' · ')}
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 shrink-0">
                      <span className="text-[10px] font-bold text-red-700 bg-red-100 px-2 py-0.5 rounded-full">{a.nb_na} NA</span>
                      <button type="button" onClick={() => ignorerDifficulte(a)} className="w-6 h-6 rounded-full flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-100" title="Ignorer cette difficulté" data-testid={`ignorer-alerte-na-${a.candidat_id}-${a.dossier_id}`}><EyeOff className="w-3.5 h-3.5" /></button>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        )}

        {/* Collaborateurs sans affectation aujourd'hui */}
        <FormateursDisponiblesCard headers={headers} />

        {/* Taches a realiser (repliées par défaut) */}
        <Card className="border-0 shadow-sm" data-testid="dashboard-taches">
          <CardHeader className="border-b bg-slate-50/50 pb-3 cursor-pointer select-none" onClick={() => setTachesOpen(v => !v)} data-testid="taches-toggle">
            <div className="flex items-center justify-between">
              <CardTitle className="flex items-center gap-2 text-base font-['Plus_Jakarta_Sans']">
                <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${tachesOpen ? 'rotate-180' : ''}`} />
                <ListChecks className="w-4 h-4 text-indigo-600" />
                Taches a realiser
                <span className="text-xs font-normal text-slate-400 ml-1">({filteredTasks.length})</span>
                {!tachesOpen && <span className="text-[11px] font-normal text-slate-400 ml-2 hidden sm:inline">— cliquer pour développer</span>}
              </CardTitle>
              <Button size="sm" className="bg-indigo-600 hover:bg-indigo-700 h-8 text-xs" onClick={(e) => { e.stopPropagation(); openCreateTask(); }} data-testid="btn-new-task">
                <Plus className="w-3.5 h-3.5 mr-1" /> Nouvelle tache
              </Button>
            </div>
          </CardHeader>
          {tachesOpen && <CardContent className="p-0">
            {/* Filters */}
            <div className="px-4 py-3 border-b flex items-center justify-between gap-4">
              <Tabs value={taskFilter} onValueChange={setTaskFilter}>
                <TabsList className="bg-slate-100 h-8">
                  <TabsTrigger value="all" className="text-xs h-7" data-testid="filter-all">Toutes</TabsTrigger>
                  <TabsTrigger value="af" className="text-xs h-7" data-testid="filter-af">AF</TabsTrigger>
                  <TabsTrigger value="financier" className="text-xs h-7" data-testid="filter-financier">Financier</TabsTrigger>
                  <TabsTrigger value="commercial" className="text-xs h-7" data-testid="filter-commercial">Commercial</TabsTrigger>
                </TabsList>
              </Tabs>
              <Tabs value={taskStatusFilter} onValueChange={setTaskStatusFilter}>
                <TabsList className="bg-slate-100 h-8">
                  <TabsTrigger value="pending" className="text-xs h-7" data-testid="filter-pending">En cours</TabsTrigger>
                  <TabsTrigger value="termine" className="text-xs h-7" data-testid="filter-done">Terminees</TabsTrigger>
                </TabsList>
              </Tabs>
            </div>

            {/* Task List */}
            {filteredTasks.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-12 text-slate-400">
                <Check className="w-8 h-8 mb-2 text-emerald-400" />
                <p className="text-sm font-medium text-slate-500">Aucune tache dans cette categorie</p>
              </div>
            ) : (
              <div className="divide-y">
                {filteredTasks.map(task => {
                  const retard = getRetard(task.date_objectif);
                  const pConf = PRIORITE_CONFIG[task.priorite] || PRIORITE_CONFIG.normal;
                  const cConf = CATEGORIE_CONFIG[task.categorie] || CATEGORIE_CONFIG.af;
                  const CatIcon = cConf.icon;
                  const hasReports = task.historique_reports?.length > 0;

                  return (
                    <div key={task.id} className={`flex items-start gap-3 px-4 py-3 hover:bg-slate-50 transition-colors group ${task.statut === 'termine' ? 'opacity-50' : ''}`} data-testid={`task-${task.id}`}>
                      {/* Status toggle */}
                      <div className="pt-0.5">
                        {task.statut === 'termine' ? (
                          <button onClick={() => changeStatus(task.id, 'a_faire')}
                            className="w-5 h-5 rounded-full bg-emerald-500 flex items-center justify-center" data-testid={`task-toggle-${task.id}`}>
                            <Check className="w-3 h-3 text-white" />
                          </button>
                        ) : task.statut === 'en_cours' ? (
                          <button onClick={() => changeStatus(task.id, 'termine')}
                            className="w-5 h-5 rounded-full border-2 border-blue-400 flex items-center justify-center" data-testid={`task-toggle-${task.id}`}>
                            <CircleDot className="w-3 h-3 text-blue-400" />
                          </button>
                        ) : (
                          <button onClick={() => changeStatus(task.id, 'en_cours')}
                            className="w-5 h-5 rounded border-2 border-slate-300 hover:border-blue-400 flex-shrink-0 transition-colors" data-testid={`task-toggle-${task.id}`} />
                        )}
                      </div>

                      {/* Priority flag */}
                      {task.priorite === 'urgent' && (
                        <Flag className="w-3.5 h-3.5 text-red-500 mt-0.5 flex-shrink-0" />
                      )}

                      {/* Retard badge */}
                      {retard && (
                        <span className={`text-[10px] font-semibold px-2 py-0.5 rounded border flex-shrink-0 whitespace-nowrap mt-0.5 ${retard.color}`}>
                          {retard.isLate && <AlertTriangle className="w-3 h-3 inline mr-0.5" />}
                          {retard.label}
                        </span>
                      )}

                      {/* Content */}
                      <div className="flex-1 min-w-0">
                        <p className={`text-sm font-medium ${task.statut === 'termine' ? 'line-through text-slate-400' : 'text-slate-800'}`}>
                          {task.titre}
                        </p>
                        {task.description && <p className="text-xs text-slate-400 mt-0.5 truncate">{task.description}</p>}
                        <div className="flex items-center gap-2 mt-1 flex-wrap">
                          <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${cConf.color}`}>
                            {cConf.label}
                          </span>
                          {task.type === 'automatique' && (
                            <span className="text-[10px] px-1.5 py-0.5 rounded bg-purple-50 text-purple-600 font-medium">Auto</span>
                          )}
                          {task.demande_devis_id && task.demande_devis && (
                            <span className="text-[10px] px-1.5 py-0.5 rounded bg-violet-50 text-violet-600 font-medium flex items-center gap-0.5">
                              <Send className="w-2.5 h-2.5" />{task.demande_devis.nom_prospect || 'Devis'}
                            </span>
                          )}
                          {task.date_objectif && (
                            <span className="text-[10px] text-slate-400 flex items-center gap-0.5">
                              <Clock className="w-3 h-3" />
                              {format(parseISO(task.date_objectif), 'd MMM yyyy', { locale: fr })}
                            </span>
                          )}
                          {task.assigne_a_nom && (
                            <span className="text-[10px] text-slate-400 flex items-center gap-0.5">
                              <Users className="w-3 h-3" />{task.assigne_a_nom}
                            </span>
                          )}
                          {task.dossier_code && (
                            <Link to={`/dossiers/${task.dossier_id}`}
                              className="text-[10px] font-mono text-indigo-500 hover:text-indigo-700 bg-indigo-50 px-1.5 py-0.5 rounded">
                              {task.dossier_code}
                            </Link>
                          )}
                          {task.projet_commercial_id && (
                            <Link to={`/commercial?projet=${task.projet_commercial_id}&filtre=tous`}
                              className="text-[10px] font-mono text-red-600 hover:text-red-700 bg-red-50 px-1.5 py-0.5 rounded flex items-center gap-0.5" data-testid={`task-projet-link-${task.id}`}>
                              <Send className="w-2.5 h-2.5" />{task.projet_commercial_code || 'Projet'}
                            </Link>
                          )}
                          {hasReports && (
                            <button onClick={() => { setHistoryTask(task); setHistoryDialogOpen(true); }}
                              className="text-[10px] text-amber-600 hover:text-amber-700 flex items-center gap-0.5" data-testid={`task-history-${task.id}`}>
                              <History className="w-3 h-3" />{task.historique_reports.length} report(s)
                            </button>
                          )}
                        </div>
                      </div>

                      {/* Actions */}
                      <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0">
                        {task.demande_devis_id && task.statut !== 'termine' && (
                          <Button variant="default" size="sm" className="h-7 px-2 text-xs bg-violet-600 hover:bg-violet-700"
                            onClick={() => openTraiterDialog(task)} data-testid={`task-traiter-${task.id}`}>
                            <Send className="w-3 h-3 mr-1" />Traiter
                          </Button>
                        )}
                        {task.date_objectif && task.statut !== 'termine' && (
                          <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => openReportDialog(task)}
                            title="Reporter la date" data-testid={`task-report-${task.id}`}>
                            <CalendarClock className="w-3.5 h-3.5 text-amber-500" />
                          </Button>
                        )}
                        <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => openEditTask(task)} data-testid={`task-edit-${task.id}`}>
                          <Pencil className="w-3.5 h-3.5 text-slate-400" />
                        </Button>
                        <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => deleteTask(task.id)} data-testid={`task-delete-${task.id}`}>
                          <Trash2 className="w-3.5 h-3.5 text-red-400" />
                        </Button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </CardContent>}
        </Card>
      </div>

      {/* Create/Edit Task Dialog */}
      <Dialog open={taskDialogOpen} onOpenChange={setTaskDialogOpen}>
        <DialogContent className="max-w-md" data-testid="task-dialog">
          <DialogHeader>
            <DialogTitle>{editTask ? 'Modifier la tache' : 'Nouvelle tache'}</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-xs">Titre</Label>
              <Input value={taskForm.titre} onChange={(e) => setTaskForm({...taskForm, titre: e.target.value})} data-testid="task-input-titre" placeholder="Ex: Relancer le devis AF-2026-001" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs">Description</Label>
              <Textarea value={taskForm.description} onChange={(e) => setTaskForm({...taskForm, description: e.target.value})} rows={2} data-testid="task-input-desc" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <Label className="text-xs">Categorie</Label>
                <Select value={taskForm.categorie} onValueChange={(v) => setTaskForm({...taskForm, categorie: v})}>
                  <SelectTrigger data-testid="task-select-cat"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="af">AF (Action de Formation)</SelectItem>
                    <SelectItem value="financier">Financier</SelectItem>
                    <SelectItem value="commercial">Commercial</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs">Priorite</Label>
                <Select value={taskForm.priorite} onValueChange={(v) => setTaskForm({...taskForm, priorite: v})}>
                  <SelectTrigger data-testid="task-select-prio"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="urgent">Urgent</SelectItem>
                    <SelectItem value="normal">Normal</SelectItem>
                    <SelectItem value="faible">Faible</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs">Date objectif</Label>
              <Input type="date" value={taskForm.date_objectif} onChange={(e) => setTaskForm({...taskForm, date_objectif: e.target.value})} data-testid="task-input-date" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs">Assigner a</Label>
              <Select value={taskForm.assigne_a || 'none'} onValueChange={(v) => setTaskForm({...taskForm, assigne_a: v === 'none' ? '' : v})}>
                <SelectTrigger data-testid="task-select-assignee"><SelectValue placeholder="Non assigne" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">Non assigne</SelectItem>
                  {adminUsers.filter(u => ['admin', 'super_admin', 'responsable_pedagogique'].includes(u.role)).map(u => (
                    <SelectItem key={u.id} value={u.id}>{u.nom} {u.prenom} ({u.role === 'super_admin' ? 'Admin' : u.role === 'responsable_pedagogique' ? 'Resp. Peda' : 'Admin'})</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs">Lier a une AF</Label>
              <Select value={taskForm.dossier_id || 'none'} onValueChange={(v) => {
                const d = allDossiers.find(x => x.id === v);
                setTaskForm({...taskForm, dossier_id: v === 'none' ? '' : v, dossier_code: d?.code || ''});
              }}>
                <SelectTrigger data-testid="task-select-dossier"><SelectValue placeholder="Aucune" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">Aucune</SelectItem>
                  {allDossiers.map(d => (
                    <SelectItem key={d.id} value={d.id}>{d.code} - {d.intitule}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setTaskDialogOpen(false)}>Annuler</Button>
            <Button onClick={saveTask} className="bg-indigo-600 hover:bg-indigo-700" data-testid="btn-save-task">
              {editTask ? 'Mettre a jour' : 'Creer'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Report Dialog */}
      <Dialog open={reportDialogOpen} onOpenChange={setReportDialogOpen}>
        <DialogContent className="max-w-md" data-testid="report-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CalendarClock className="w-5 h-5 text-amber-500" />
              Reporter la date objectif
            </DialogTitle>
          </DialogHeader>
          {reportTask && (
            <div className="space-y-4">
              <div className="p-3 rounded-lg bg-slate-50 border">
                <p className="text-sm font-medium text-slate-800">{reportTask.titre}</p>
                <p className="text-xs text-slate-500 mt-1">
                  Date actuelle : {reportTask.date_objectif ? format(parseISO(reportTask.date_objectif), 'd MMMM yyyy', { locale: fr }) : 'Non definie'}
                </p>
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs">Nouvelle date</Label>
                <Input type="date" value={reportForm.nouvelle_date} onChange={(e) => setReportForm({...reportForm, nouvelle_date: e.target.value})} data-testid="report-input-date" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs">Raison du report <span className="text-red-500">*</span></Label>
                <Textarea value={reportForm.raison} onChange={(e) => setReportForm({...reportForm, raison: e.target.value})} rows={3} placeholder="Expliquez pourquoi cette date est modifiee..." data-testid="report-input-raison" />
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setReportDialogOpen(false)}>Annuler</Button>
            <Button onClick={submitReport} className="bg-amber-600 hover:bg-amber-700" data-testid="btn-submit-report">Reporter</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* History Dialog */}
      <Dialog open={historyDialogOpen} onOpenChange={setHistoryDialogOpen}>
        <DialogContent className="max-w-md" data-testid="history-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <History className="w-5 h-5 text-amber-500" />
              Historique des reports
            </DialogTitle>
          </DialogHeader>
          {historyTask && (
            <div className="space-y-3">
              <p className="text-sm font-medium text-slate-800">{historyTask.titre}</p>
              <div className="space-y-2 max-h-64 overflow-y-auto">
                {(historyTask.historique_reports || []).map((r, i) => (
                  <div key={`${r.ancienne_date || ''}-${r.nouvelle_date}-${i}`} className="p-3 rounded-lg border bg-amber-50/50 text-sm">
                    <div className="flex items-center gap-2 text-xs text-amber-700 font-medium">
                      <ArrowRight className="w-3 h-3" />
                      {r.ancienne_date ? format(parseISO(r.ancienne_date), 'd MMM yyyy', { locale: fr }) : '?'} → {format(parseISO(r.nouvelle_date), 'd MMM yyyy', { locale: fr })}
                    </div>
                    <p className="text-xs text-slate-600 mt-1.5 italic">"{r.raison}"</p>
                    <p className="text-[10px] text-slate-400 mt-1">
                      Par {r.par_nom || 'Inconnu'} le {format(parseISO(r.date_report), 'd MMM yyyy HH:mm', { locale: fr })}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
          <DialogFooter>
            <Button onClick={() => setHistoryDialogOpen(false)} className="bg-indigo-600 hover:bg-indigo-700">Fermer</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* TRAITER DEMANDE DE DEVIS DIALOG */}
      <Dialog open={traiterDialogOpen} onOpenChange={setTraiterDialogOpen}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="traiter-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Send className="w-5 h-5 text-violet-500" />
              Traiter la demande de devis
            </DialogTitle>
          </DialogHeader>
          {traiterTask?.demande_devis && (
            <div className="space-y-4">
              {/* Recap de la demande */}
              <div className="p-3 rounded-lg bg-violet-50 border border-violet-200">
                <p className="text-xs font-semibold text-violet-700 uppercase mb-2">Demande du commercial</p>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div><span className="text-slate-500">Prospect :</span> <span className="font-medium">{traiterTask.demande_devis.nom_prospect}</span></div>
                  <div><span className="text-slate-500">Objet :</span> <span className="font-medium">{traiterTask.demande_devis.objet}</span></div>
                  {traiterTask.demande_devis.duree && <div><span className="text-slate-500">Duree :</span> {traiterTask.demande_devis.duree}</div>}
                  {traiterTask.demande_devis.nombre_stagiaires && <div><span className="text-slate-500">Stagiaires :</span> {traiterTask.demande_devis.nombre_stagiaires}</div>}
                  {traiterTask.demande_devis.dates_souhaitees && <div><span className="text-slate-500">Dates souhaitees :</span> {traiterTask.demande_devis.dates_souhaitees}</div>}
                  {traiterTask.demande_devis.lieu && <div><span className="text-slate-500">Lieu :</span> {traiterTask.demande_devis.lieu}</div>}
                  {traiterTask.demande_devis.specificites && <div className="col-span-2"><span className="text-slate-500">Specificites :</span> {traiterTask.demande_devis.specificites}</div>}
                  {traiterTask.demande_devis.notes && <div className="col-span-2"><span className="text-slate-500">Notes :</span> {traiterTask.demande_devis.notes}</div>}
                </div>
              </div>

              {/* Choix: AF existante ou nouvelle */}
              <div className="space-y-2">
                <Label className="text-xs font-semibold">Action de Formation</Label>
                <div className="flex gap-2">
                  <Button variant={traiterMode === 'existante' ? 'default' : 'outline'} size="sm"
                    onClick={() => setTraiterMode('existante')}
                    className={traiterMode === 'existante' ? 'bg-indigo-600' : ''} data-testid="mode-af-existante">
                    <Search className="w-3 h-3 mr-1" />Lier a une AF existante
                  </Button>
                  <Button variant={traiterMode === 'nouvelle' ? 'default' : 'outline'} size="sm"
                    onClick={() => setTraiterMode('nouvelle')}
                    className={traiterMode === 'nouvelle' ? 'bg-indigo-600' : ''} data-testid="mode-af-nouvelle">
                    <Plus className="w-3 h-3 mr-1" />Creer une nouvelle AF
                  </Button>
                </div>
              </div>

              {traiterMode === 'existante' && (
                <div className="space-y-1.5">
                  <Label className="text-xs">Selectionner l'AF *</Label>
                  <Select value={traiterForm.action_formation_id || 'none'}
                    onValueChange={v => setTraiterForm({...traiterForm, action_formation_id: v === 'none' ? '' : v})}>
                    <SelectTrigger data-testid="traiter-af-select"><SelectValue placeholder="Choisir une AF..." /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="none">-- Selectionner --</SelectItem>
                      {allDossiers.map(d => (
                        <SelectItem key={d.id} value={d.id}>{d.code} — {d.intitule} ({d.client || 'Sans client'})</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              )}

              {traiterMode === 'nouvelle' && (
                <div className="space-y-3 p-3 rounded-lg border border-indigo-200 bg-indigo-50/30">
                  <p className="text-xs font-semibold text-indigo-700">Nouvelle Action de Formation</p>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="col-span-2 space-y-1.5">
                      <Label className="text-xs">Formation *</Label>
                      <FormationPicker formations={formations} value={traiterForm.formation_id} testId="traiter-formation-select" placeholder="Choisir une formation..."
                        onChange={(v, f) => setTraiterForm({...traiterForm, formation_id: v, intitule: f?.titre || traiterForm.intitule})} />
                    </div>
                    <div className="col-span-2 space-y-1.5">
                      <Label className="text-xs">Intitule</Label>
                      <Input value={traiterForm.intitule} onChange={e => setTraiterForm({...traiterForm, intitule: e.target.value})} data-testid="traiter-intitule" />
                    </div>
                    <div className="col-span-2 space-y-1.5">
                      <Label className="text-xs">Lieu</Label>
                      <Input value={traiterForm.lieu_principal} onChange={e => setTraiterForm({...traiterForm, lieu_principal: e.target.value})} data-testid="traiter-lieu" />
                    </div>
                  </div>
                  <p className="text-[10px] text-indigo-500 mt-1">Vous pourrez completer le dossier (client, financeur, candidats, dates) apres la creation.</p>
                </div>
              )}

              {/* Financeur, candidats, dates → seront completes dans le dossier AF */}
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setTraiterDialogOpen(false)}>Annuler</Button>
            <Button onClick={submitTraiter} disabled={traiterLoading}
              className="bg-violet-600 hover:bg-violet-700" data-testid="btn-submit-traiter">
              {traiterLoading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Send className="w-4 h-4 mr-2" />}
              {traiterMode === 'nouvelle' ? "Creer l'AF et ouvrir le dossier" : "Ouvrir le dossier"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
};
